module.exports = __webpack_public_path__ + "static/media/icon_email.051dc892.svg";